import React from 'react';
import {Card,CardActions,CardContent,Button,Typography} from "@material-ui/core";
export default [{
  name: 'typy',
  render: (
    <Card className='portfolio-item' style={{paddingBottom:"3vh",paddingLeft:"1vw",paddingRight:"1vw"}}>
        <CardContent>
      <Typography variant="h3" component="h2">
          Generative Image Inpainting using Deep Learning
        </Typography>
        <Typography variant="h4" component="h2" style={{paddingTop:"5vh"}}>
        Research Thesis on filling of Large patches in images using LSGAN and Encoder.
        </Typography>
      <div style={{paddingTop:"5vh",fontSize:"2em"}}>
      <i className="fa fa-github"></i>
        </div>
        </CardContent>
        <CardActions>
        <a size="small" href="https://github.com/shadowshot-x/Generative-Image-Inpainting-using-Deep-Learning">Learn More</a>
      </CardActions>
    </Card>
  )
},{
  name: 'typy',
  render: (
    <Card className='portfolio-item' style={{paddingBottom:"3vh",paddingLeft:"1vw",paddingRight:"1vw"}}>
        <CardContent>
      <Typography variant="h3" component="h2">
          Janata Hack 2020
        </Typography>
        <Typography variant="h4" component="h2" style={{paddingTop:"5vh"}}>
        Ranked 36/400 for Multi Class Multi Label Text Classification using Deep Learning and Machine Learning Applications. 
        </Typography>
      <div style={{paddingTop:"5vh",fontSize:"2em"}}>
      <i className="fa fa-github"></i>
        </div>
        </CardContent>
        <CardActions>
        <a size="small" href="https://github.com/shadowshot-x/JANATA-HACK-NLP-2020">Learn More</a>
      </CardActions>
    </Card>
  )
},{
  name: 'typy',
  render: (
    <Card className='portfolio-item' style={{paddingBottom:"3vh",paddingLeft:"1vw",paddingRight:"1vw"}}>
        <CardContent>
      <Typography variant="h3" component="h2">
          Knowsearch
        </Typography>
        <Typography variant="h4" component="h2" style={{paddingTop:"5vh"}}>
        An Educational Search Engine with Web Scraper and a personal Blog along with a personal WYSIWYG Editor.
        </Typography>
      <div style={{paddingTop:"5vh",fontSize:"2em"}}>
      <i className="fa fa-github"></i>
        </div>
        </CardContent>
        <CardActions>
        <a size="small" href="https://www.knowsearch.ml">Learn More</a>
      </CardActions>
    </Card>
  )
}, {
  name: 'dev-landing-page',
  render: (
    <Card className='portfolio-item' style={{paddingBottom:"3vh",paddingLeft:"1vw",paddingRight:"1vw"}}>
        <CardContent>
      <Typography variant="h3" component="h2">
          ResuMy
        </Typography>
        <Typography variant="h4" component="h2" style={{paddingTop:"5vh"}}>
        A React-Redux and Node Powered Application that assists in Building Resume without the requirement of Latex.
        </Typography>
      <div style={{paddingTop:"5vh",fontSize:"2em"}}>
      <i className="fa fa-github"></i>
        </div>
        </CardContent>
        <CardActions>
        <a size="small" href="https://github.com/shadowshot-x/Resume-Builder">Learn More</a>
      </CardActions>
    </Card>
  )
}, {
  name: 'react-redux-boilerplate',
  render: (
    <Card className='portfolio-item' style={{paddingBottom:"3vh",paddingLeft:"1vw",paddingRight:"1vw"}}>
        <CardContent>
      <Typography variant="h3" component="h2">
          DEPS
        </Typography>
        <Typography variant="h4" component="h2" style={{paddingTop:"5vh"}}>
        Decentralized System with solidity and Node to empower the integrity of important Documents for safe upload and prevent tampering.
        </Typography>
      <div style={{paddingTop:"5vh",fontSize:"2em"}}>
      <i className="fa fa-github"></i>
        </div>
        </CardContent>
        <CardActions>
        <a size="small" href="https://github.com/shadowshot-x/HackBMU2019_TheWanderars">Learn More</a>
      </CardActions>
    </Card>
  )
}, {
  name: 'npm-module-boilerplate',
  render: (
    <Card className='portfolio-item' style={{paddingBottom:"3vh",paddingLeft:"1vw",paddingRight:"1vw"}}>
        <CardContent>
      <Typography variant="h3" component="h2">
          Canteen Services
        </Typography>
        <Typography variant="h4" component="h2" style={{paddingTop:"5vh"}}>
        Django Powered Food Ordering Platform for the Personal College Canteen presented in AASF Winter Challenge along with Authentication.
        </Typography>
      <div style={{paddingTop:"5vh",fontSize:"2em"}}>
      <i className="fa fa-github"></i>
        </div>
        </CardContent>
        <CardActions>
        <a size="small" href="https://github.com/shadowshot-x/Canteen_services">Learn More</a>
      </CardActions>
    </Card>
  )
}, {
  name: 'axios-retry-interceptor',
  render: (
    <Card className='portfolio-item' style={{paddingBottom:"3vh",paddingLeft:"1vw",paddingRight:"1vw"}}>
        <CardContent>
      <Typography variant="h3" component="h2">
          Mental Health Web
        </Typography>
        <Typography variant="h4" component="h2" style={{paddingTop:"5vh"}}>
        An Optimized Web Platform to provide people knowledge about Mental Health with Real Time Chat and Quiz functionality with Octa Auth and a blog.
        </Typography>
      <div style={{paddingTop:"5vh",fontSize:"2em"}}>
      <i className="fa fa-github"></i>
        </div>
        </CardContent>
        <CardActions>
        <a size="small" href="https://github.com/shadowshot-x/Mental-Health-Site">Learn More</a>
      </CardActions>
    </Card>
  )
}, {
  name: 'browser-or-node',
  render: (
    <Card className='portfolio-item' style={{paddingBottom:"3vh",paddingLeft:"1vw",paddingRight:"1vw"}}>
        <CardContent>
      <Typography variant="h3" component="h2">
         StuNation
        </Typography>
        <Typography variant="h4" component="h2" style={{paddingTop:"5vh"}}>
        Blockchain based Bidding Platform where Entreprenuers can present Ideas and find Investors while providing a breif description of their project.
        </Typography>
      <div style={{paddingTop:"5vh",fontSize:"2em"}}>
      <i className="fa fa-github"></i>
        </div>
        </CardContent>
        <CardActions>
        <a size="small" href="https://github.com/siddharthjain1611/Stunation">Learn More</a>
      </CardActions>
    </Card>
  )
}]



// WEBPACK FOOTER //
// ./src/components/PORTFOLIO/portflio-items.js